import { createSelector } from 'reselect';
import { RootState } from '../reducers';

const stateSelector = (state: RootState) => state.search;

export const searchTextSelector = createSelector(stateSelector, (value) => value.searchText);
export const searchTagsSelector = createSelector(stateSelector, (value) => value.searchTags);
export const regionSelector = createSelector(stateSelector, (value) => value.region);
export const selectedTagSelector = createSelector(stateSelector, (value) => value.selectedSearchTag);
